import React, { Component } from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as actionsCookie from '../../actions/actionCookie.js';


export class Cookie extends Component {

    hide() {
        this.props.actionCookie.setCookie();
    }

    render(){
        let template = <div className="cookie-warning" id="cookie-warning">
            <div className="center-box" style={{display: 'flex', justifyContent: 'space-around'}}>
                <span style={{width:'90%'}}>Данный сайт использует cookie-файлы, а также собирает данные об IP-адресе и местоположении с целью предоставления наиболее корректной информации по Вашему запросу.
                    Продолжая использовать данный ресурс, Вы автоматически соглашаетесь с использованием данных технологий.
                </span>
                <div className="close-cookie">
                    <i onClick={this.hide.bind(this)} className="fa fa-window-close"></i>
                </div>
            </div>
        </div>;
        return(
            this.props.cookie_warning ? null : template
        )
    }
}

function mapStateToProps(state) {
    return {
        cookie_warning: state.cookieWarning.cookie_warning
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actionCookie: bindActionCreators(actionsCookie, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Cookie);




// WEBPACK FOOTER //
// frontend/src/modules/template/Cookie.jsx